import { RequestDraftToken } from "$src/application/projects/sub/drafts/commands/RequestDraft";
import { TakeOverDraft, TakeOverDraftToken } from "$src/application/projects/sub/drafts/commands/TakeOverDraft";
import { DraftPermission } from "$src/domain/projects/drafts/DraftPermission";
import { useMutation } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function takeOverDraft(groupStoreId: number, projectId: number)
    : Promise<DraftPermission> {

    const query = container.resolve<TakeOverDraft>(TakeOverDraftToken);
    return query.execute(groupStoreId, projectId);
}

export function useTakeOverDraft() {
    return useMutation(
        ({ groupStoreId, projectId }: 
            { groupStoreId: number, projectId: number }
        ) => takeOverDraft(groupStoreId, projectId)
    );
}